// src/services/authApi.ts
import axios from "axios";
import { getAttribution } from "./attribution";
import { metaCookies } from "./metaPixel";
import apiClient, { BASE_URL } from "./apiClient";

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  user: {
    _id: string;
    email: string;
    isPaid: boolean;
    isVerified: boolean;
  };
}

export interface UserContactProfile {
  _id: string;
  name: string;
  businessName: string;
  email: string;
  accountEmail: string;
  phone: string;
  address: string;
}

export const loginApi = (email: string, password: string) =>
  apiClient.post<LoginResponse>("/auth/login", { email, password });

/** Optional sign-up details, the same ones the mobile app asks for. */
export interface RegisterDetails {
  businessName?: string;
  country?: string;
  currency?: string;
}

export const registerApi = (
  name: string,
  email: string,
  password: string,
  details: RegisterDetails = {}
) =>
  apiClient.post("/auth/create", {
    name,
    email: email.trim().toLowerCase(),
    password,
    businessName: details.businessName?.trim() || undefined,
    country: details.country || undefined,
    currency: details.currency || undefined,
    // Which ad brought them, if any (utm tags / fbclid).
    attribution: getAttribution(),
    // Marks a website sign-up; the server reports it to Meta once verified.
    adSignals: metaCookies(),
  });

export const logoutApi = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  return axios.post(`${BASE_URL}/auth/logout`, { refreshToken });
};

export const verifyEmailApi = (email: string, code: string) =>
  apiClient.post("/auth/verify-email", { email, code });

export const resendVerificationApi = (email: string) =>
  apiClient.post("/auth/resend-verification", { email });
// 🔄 Forgot Password API
export const forgotPasswordApi = (email: string) =>
  apiClient.post("/auth/forgot-password", { email });

// 🆕 Reset Password API
export const resetPasswordApi = (token: string, newPassword: string) =>
  apiClient.post(`/auth/reset-password/${token}`, { newPassword });

export const getMyContactProfileApi = () =>
  apiClient.get<UserContactProfile>("/auth/me/contact-profile");

export const updateMyContactProfileApi = (body: {
  name: string;
  businessName?: string;
  email: string;
  phone?: string;
  address?: string;
}) => apiClient.put<UserContactProfile>("/auth/me/contact-profile", body);
